import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Form,
    Message,
    Divider,
    Icon,
    Item,
    Select,
} from 'semantic-ui-react';

//IMPORT IMAGES
import hommeShapeWhite from '../../assets/icons/homme-shape-white.png'
import hommeShapeGrey from '../../assets/icons/homme-shape-grey.png'
import femmeShapeGrey from '../../assets/icons/femme-shape-grey.png';
import femmeShapeWhite from '../../assets/icons/femme-shape-white.png';
import particulierWhite from '../../assets/icons/particulier-white.png';
import particulierGrey from '../../assets/icons/particulier-grey.png';
import professionelGrey from '../../assets/icons/professionel-grey.png';
import professionelWhite from '../../assets/icons/professionel-white.png';

import { translate } from "react-translate";
import Exit from '../../assets/svg/Exit.svg';

import { connect } from 'react-redux';

import { addModal } from '../../redux/actions/AppAction'

import API from '../../services/api';

const mapStateToProps = state => ({
    app: state.app
})

const mapActionToProps = {
    addModal: addModal
}


class ConnectedRegisterSocial extends Component {

    constructor(props) {
        super(props);

        this.state = {
            email: this.props.email,
            name: this.props.name,
            provider: this.props.provider,
            gender: 1,
            user_type: 0,
            country: 250,
            countryId: 250,
            postalCode: 0,
            errorRegister: null,
        }

        this.handleClickGender = this.handleClickGender.bind(this);
        this.handleClickPro = this.handleClickPro.bind(this)
        this.handleChangePostalcode = this.handleChangePostalcode.bind(this);
        this.handleSubmitRegister = this.handleSubmitRegister.bind(this);

        this.handleChange = this.handleChange.bind(this);
        this.addModal = this.addModal.bind(this);
    }

    handleClickGender(e) {
        e.preventDefault();

        let value = e.target.value != undefined ? e.target.value : e.target.getAttribute('value');

        this.setState({
            gender: value
        })
    }

    handleClickPro(e) {
        e.preventDefault();

        let value = e.target.value != undefined ? e.target.value : e.target.getAttribute('value');

        this.setState({
            user_type: value
        })
    }

    handleChangePostalcode(e, data) {
        e.preventDefault();
        this.setState({
            postalCode: data.value
        })
    }

    addModal(value) {
        this.props.addModal(value);
    }

    handleChange(e, data) {
        e.preventDefault();
        let countryId
        Object.entries(this.state.responseCountry).map((key, mainindex) => {
            if (key[1].text === data.value) {
                countryId = key[1].key
            }
        })
        this.setState({
            countryId: countryId
        })
    }


    handleSubmitRegister(event) {
        event.preventDefault();
        let provid;
        if (this.state.provider === 'google') {
            provid = 'GG'
        } else {
            provid = 'FB'
        }

        var that = this;
        var registerData = {
            email: this.state.email,
            password: this.state.name,
            name: this.state.name,
            gender: this.state.gender,
            country: this.state.countryId,
            postalcode: this.state.postalCode,
            lang: this.props.app.lang,
            type: provid,
            user_type: this.state.user_type
        }
        API.register(this.props.token, registerData).then((res) => {
            var response = res.data;
            if(response && response.code == 200) {
                that.addModal(false);
            } else {
                that.setState({
                    errorRegister: response
                })
            }
        });

    }

    componentDidMount() {
        var pwd = this
        var langData = {
            lang : this.props.app.lang
        }
        API.getCountries(this.props.app.token, langData).then((res) => {
            var response = res.data;
            let tmp = []
            Object.entries(response).map((key, mainindex) => {
                if (key[0] === 'countries') {
                    Object.entries(key[1]).map((key, mainindex) => {
                        var countries = {}
                        countries.key = key[1].pkuid
                        countries.text = key[1].name
                        countries.value = key[1].name
                        tmp.push(countries)
                    })
                }
            })
            pwd.setState({
                responseCountry: tmp
            })
        }, (rej) => {
            pwd.setState({
                error: rej.error
            })
        });
    }

    render() {
        const { t} = this.props
        return (


                <Grid
                    textAlign='center'
                    verticalAlign='middle'
                    padded>
                    <Grid.Column style={{ maxWidth: 390 }}>
                        <Image
                          src={Exit}
                          verticalAlign='middle'
                          floated='right'
                          id="exit"
                          onClick={() => this.addModal(false)} />
                        <Header as='h2' id="modalRegisterHeader">
                            {t('title')}
                        </Header>
                        <Form onSubmit={this.handleSubmitRegister} id="formRegister">
                            <Form.Input
                                value={this.state.name}
                                disabled
                                fluid />
                            <Form.Input
                                value={this.state.email}
                                disabled
                                fluid />
                            <Form.Input
                                disabled
                                type={'password'}
                                value={this.props.name}
                                fluid />
                            <Grid>
                                <Grid.Row columns={3} style={{paddingBottom:'0'}}>
                                    <Grid.Column  textAlign='left' verticalAlign='middle' style={{ flexGrow: '1' }}>
                                        <Item.Header as='h5' className="label">{t("gender")}</Item.Header>
                                    </Grid.Column>

                                    <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }} >
                                    {
                                        this.state.gender == 1 ? (
                                          <Button onClick={this.handleClickGender} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff', marginLeft: '20px' }}>
                                              <Image value={1} src={hommeShapeWhite} /> {t('male')}
                                          </Button>

                                        ) : (

                                              <Button onClick={this.handleClickGender} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)', marginLeft: '20px' }} >
                                                  <Image value={1} src={hommeShapeGrey} /> {t('male')}
                                              </Button>

                                            )
                                    }
                                    </Grid.Column>

                                    <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                        {
                                            this.state.gender == 0 ? (

                                              <Button onClick={this.handleClickGender} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff' }}>
                                                  <Image value={0} src={femmeShapeWhite} /> {t('female')}
                                              </Button>

                                            ) : (

                                                <Button onClick={this.handleClickGender} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)' }}>
                                                    <Image value={0} src={femmeShapeGrey} />{t('female')}
                                                </Button>

                                                )
                                        }
                                    </Grid.Column>
                                </Grid.Row>

                                <Grid.Row columns={3} style={{paddingBottom:'0'}}>

                                  <Grid.Column  textAlign='left' verticalAlign='middle'>
                                      <Item.Header as='h5' className="label">{t("pro")}</Item.Header>
                                  </Grid.Column>

                                  <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                      {
                                          this.state.user_type == 0 ? (

                                              <Button onClick={this.handleClickPro} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff', marginLeft: '20px' }}>
                                                  <Image value={0} src={particulierWhite} /> {t('particulier')}
                                              </Button>
                                          ) : (
                                                  <Button onClick={this.handleClickPro} value={0} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)', marginLeft: '20px' }}>
                                                      <Image value={0} src={particulierGrey} /> {t('particulier')}
                                                  </Button>

                                              )
                                      }
                                  </Grid.Column>
                                  <Grid.Column verticalAlign='middle' style={{ flexGrow: '2' }}>
                                      {
                                          this.state.user_type == 1 ? (
                                              <Button onClick={this.handleClickPro} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(9, 99, 192)', color: '#fff' }}>
                                                  <Image value={1} src={professionelWhite} /> {t('professional')}
                                              </Button>

                                          ) : (

                                                  <Button onClick={this.handleClickPro} value={1} fluid size='medium' className="btnRegisterPicto" style={{ backgroundColor: 'rgb(247, 247, 248)' }}>
                                                      <Image value={1} src={professionelGrey} /> {t('professional')}
                                                  </Button>
                                              )
                                      }
                                  </Grid.Column>


                                </Grid.Row>

                                <Grid.Row columns={2}>
                                    <Grid.Column textAlign='left' verticalAlign='middle' width={5}>
                                        <Item.Header as='h5' className="label">{t("country")}</Item.Header>
                                    </Grid.Column>

                                    <Grid.Column width={11}>
                                        <Dropdown
                                            selection
                                            search
                                            defaultValue='France'
                                            onChange={this.handleChange}
                                            options={this.state.responseCountry}
                                            style={{ borderColor: 'rgb(160, 160, 160)' }}
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <Form.Input
                                onChange={this.handleChangePostalcode}
                                fluid
                                placeholder='Code Postal *' />
                            <Button
                              onClick={this.handleSubmitRegister}
                              fluid size='large'
                              color='yellow'
                              id="submitRegisterBtn">
                                {t("register")}
                              </Button>
                        </Form>
                        {
                            this.state.errorRegister ? (
                                this.state.errorRegister.code === 302 ? (
                                    <Segment>
                                        <Header as="h5" id="account">{t("email_error")}</Header>
                                    </Segment>
                                ):(
                                    <div></div>
                                )
                            ):(
                                <div></div>
                            )
                        }
                    </Grid.Column>
                </Grid>
        )
    }
}


const RegisterSocial = connect(mapStateToProps, mapActionToProps)(ConnectedRegisterSocial);
export default translate("RegisterSocial")(RegisterSocial);



// WEBPACK FOOTER //
// ./src/components/Login/RegisterSocial.js